'use strict';

var DEFAULT_LOCALE = 'en-US';
var formats = {
    'en-US': 'MM/DD/YYYY',
    'en-GB': 'DD/MM/YYYY',
};
var getFormat = function (locale) {
    if (locale === void 0) { locale = DEFAULT_LOCALE; }
    var format = formats[locale];
    return format !== null && format !== void 0 ? format : formats[DEFAULT_LOCALE];
};
var Dates = {
    DEFAULT_LOCALE: DEFAULT_LOCALE,
    formats: formats,
    getFormat: getFormat,
};

module.exports = Dates;
